import { NotifyProgressProps } from '@billy/design-system'
import { TFunction } from 'i18next'

import { DownloadStatus } from '../../../../../../../types/downloadStatus'
import { downloadStatusToProgressVariant } from '../../../../../../../utils/export/downloadStatusToProgressVariant'
import { downloadStatusToTKeys } from '../../../../../../../utils/export/downloadStatusToTKeys'

interface GetProgressNotificationPayloadProps {
  id: string
  progress: number
  status: DownloadStatus
  t: TFunction
}

export const getProgressNotificationPayload = ({
  id,
  progress,
  status,
  t,
}: GetProgressNotificationPayloadProps): NotifyProgressProps => {
  const tKeys = downloadStatusToTKeys[status]

  return {
    id,
    title: t(tKeys.title),
    description: t(tKeys.description),
    progress: progress * 100,
    variant: downloadStatusToProgressVariant[status],
    closable: status !== 'processing',
  }
}
